<!-- this component renders any of the different possible values that can be passed in config or are passed from sap. -->
@if (config.type === 'left-text') {
  <div
    class="flex !h-full items-center justify-start whitespace-nowrap text-left"
    [ngClass]="config.class"
    [matTooltip]="config.tooltip"
  >
    @if (isClickable) {
      <button
        type="button"
        class="clickable hover flex w-[90%] text-left"
        [class.highlight]="shouldHighlight"
        (click)="handleTextClicked()"
      >
        <span class="w-100 overflow-hidden text-ellipsis" [innerHTML]="value"></span>
      </button>
    } @else {
      <span class="flex w-[90%] pl-1.5 text-left" [class.highlight]="shouldHighlight">
        <span class="w-100 overflow-hidden text-ellipsis" [innerHTML]="value"></span>
      </span>
    }
  </div>
} @else if (config.type === 'text') {
  <div class="flex !h-full items-center justify-center text-center" [ngClass]="config.class" [class.total-row-value]="isTotalRow">
    @if (isTotalRow || !config.shouldTextRemoveZerosFromNonTotalRow) {
      <div class="!h-auto">
        {{ shouldOmitStringsAndZeros(value) ? value : (value | trimDecimal: 2) }}
      </div>
    }
    @if (!isTotalRow && config.shouldTextRemoveZerosFromNonTotalRow) {
      <div class="!h-auto">
        {{ value | hideZeroes }}
      </div>
    }
  </div>
} @else if (config.type === 'number-box') {
  <div class="h-full w-full" [class.total-row-value]="isTotalRow">
    @if (isTotalRow) {
      <div class="flex items-center justify-center">
        {{ value | hideZeroes }}
      </div>
    } @else {
      <button
        type="button"
        class="number-box-button separated-box hover h-full"
        matRipple
        [class.highlight]="shouldHighlight"
        (click)="handleCellClicked()"
      >
        {{ value | hideZeroes }}
      </button>
    }
  </div>
} @else if (config.type === 'plain-button') {
  <div class="flex items-center justify-center" [ngClass]="config.class">
    <button
      class="w-full"
      mat-raised-button
      [disabled]="config.isReadOnly"
      [matTooltip]="config.tooltip"
      (click)="handlePlainButtonClicked()"
    >
      @if (config.icon) {
        <mat-icon>{{ config.icon }}</mat-icon>
      } @else if (config.svgIcon) {
        <mat-icon [svgIcon]="config.svgIcon" />
      }
      <span class="block w-full overflow-hidden text-ellipsis">
        {{ display.trim() === '' ? '&nbsp;' : display }}
      </span>
    </button>
  </div>
} @else if (config.type === 'embedded-text') {
  <div
    class="separated-box primary-hover flex !h-auto !w-auto cursor-pointer flex-row justify-between overflow-hidden bg-white"
    [class.highlight]="shouldHighlight"
    (click)="handleCellClicked()"
  >
    <span class="max-w-[15%] basis-full text-xs">{{ config.header }}</span>
    <button
      type="button"
      class="number-box-button hover flex w-full break-all text-left text-xs !opacity-100"
      (click)="handleCellClicked()"
    >
      {{ value }}
    </button>
  </div>
} @else if (config.type === 'bold-text') {
  <div
    class="flex !h-full items-center justify-center text-sm font-bold"
    [ngClass]="config.class"
    [class.totalTotalText]="!config.tooltip && !isClickable"
  >
    <button
      type="button"
      class="w-[90%]"
      matRipple
      [matTooltip]="config.tooltip"
      [matRippleDisabled]="isTotalRow || !isClickable"
      [ngClass]="{ 'clickable hover': !isTotalRow && isClickable }"
      [attr.tabindex]="isTotalRow || !isClickable ? -1 : null"
      (click)="handleTextClicked()"
    >
      {{ shouldOmitStringsAndZeros(value) ? value : (value | trimDecimal: 2) }}
    </button>
  </div>
} @else if (config.type === 'number-grid') {
  <div class="w-full" [class.total-row-value]="isTotalRow" [ngClass]="config.class">
    <button
      type="button"
      class="hover flex h-full w-full items-center justify-center"
      matRipple
      [matRippleDisabled]="isTotalRow || !isClickable"
      [ngClass]="{ hover: !isTotalRow && isClickable }"
      [attr.tabindex]="isTotalRow ? -1 : null"
      (click)="handleCellClicked()"
    >
      <payroll-day-grid
        class="hover flex flex-row items-center justify-around"
        [data]="dataAsNumberGrid(value)"
        [ngClass]="{ highlight: shouldHighlight, 'clickable separated-box': !isTotalRow }"
      />
    </button>
  </div>
} @else if (config.type === 'hours') {
  <div>
    <mat-form-field class="w-full" [matTooltip]="config.tooltip" [ngClass]="config.class" (click)="focusInput(inputRef)">
      @if (formLabel) {
        <mat-label>{{ formLabel }}</mat-label>
      }
      <input
        #inputRef
        matInput
        floatLabel="true"
        type="number"
        min="0"
        class="text-center"
        [disabled]="config.isReadOnly"
        [(ngModel)]="value"
        (blur)="validateHours(inputRef)"
        (keyup)="handleValueChanged()"
      />
    </mat-form-field>
  </div>
} @else if (config.type === 'time') {
  <div [ngClass]="config.class">
    <mat-form-field
      class="w-full"
      floatLabel="always"
      [ngClass]="{ removeMatStyling: config.shouldRemoveMatStyling }"
      [matTooltip]="config.tooltip"
    >
      @if (formLabel) {
        <mat-label>{{ formLabel }}</mat-label>
      }
      <input
        matInput
        type="time"
        class="text-center"
        [disabled]="config.isReadOnly || config.isDisabled"
        [(ngModel)]="value"
        (keyup)="handleValueChanged()"
      />
    </mat-form-field>
  </div>
} @else if (config.type === 'checkbox') {
  <div class="flex items-center justify-center">
    <mat-checkbox color="primary" [(ngModel)]="value" (change)="handleDebouncedValueChange()" />
  </div>
} @else if (config.type === 'select' || config.type === 'L1') {
  <div [ngClass]="config.class">
    <mat-form-field class="w-[90%]" floatLabel="always" [matTooltip]="config.tooltip">
      @if (formLabel && formLabel !== value) {
        <mat-label>{{ formLabel }}</mat-label>
      } @else if (upperCaseDescription !== upperCaseStringValue) {
        <mat-label>{{ value }}</mat-label>
      }
      <mat-select
        [class.-mt-3]="(formLabel && formLabel === value) || upperCaseDescription === upperCaseStringValue"
        [disabled]="config.isReadOnly"
        [(ngModel)]="value"
        (selectionChange)="handleSelectValueChange()"
      >
        @for (option of config.selectOptions; track option) {
          <mat-option [value]="option?.value">
            {{ option?.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
} @else if (config.type === 'text-input' || config.type === 'AN') {
  <div [ngClass]="config.class">
    <mat-form-field
      class="h-full w-full"
      floatLabel="always"
      [ngClass]="{ removeMatStyling: config.shouldRemoveMatStyling }"
      [matTooltip]="config.tooltip"
    >
      @if (formLabel) {
        <mat-label>{{ formLabel }}</mat-label>
      }
      @if (formLabel) {
        <div class="pt-1.5"></div>
      }
      <textarea
        #autosize="cdkTextareaAutosize"
        matInput
        class="resize-none self-center leading-5"
        cdkTextareaAutosize
        [cdkAutosizeMinRows]="config.minTextRows"
        [cdkAutosizeMaxRows]="config.maxTextRows"
        [maxLength]="config.maxTextLength"
        [disabled]="canEdit || config.isReadOnly"
        [(ngModel)]="value"
        (keyup)="handleValueChanged()"
        (keydown.enter)="handleEnterPressed($event)"
      >
      </textarea>
    </mat-form-field>
  </div>
} @else if (config.type === 'spacer') {
  <div>
    <span></span>
  </div>
} @else if (config.type === 'currency-input') {
  <div>
    <mat-form-field
      class="w-full"
      floatLabel="always"
      [matTooltip]="config.tooltip"
      [ngClass]="config.class"
      (click)="focusInput(inputRef)"
    >
      @if (formLabel) {
        <mat-label>{{ formLabel }}</mat-label>
      }
      <input
        #inputRef
        matInput
        type="number"
        placeholder="0.00"
        min="0.00"
        [disabled]="config.isReadOnly || config.isDisabled"
        [(ngModel)]="value"
        (keypress)="onlyNumberKey($event)"
        (keyup)="handleValueChanged()"
      />
      <span matTextPrefix>$&nbsp;</span>
    </mat-form-field>
  </div>
} @else if (config.type === 'input' || config.type === 'I') {
  <div>
    <mat-form-field
      class="w-full"
      floatLabel="always"
      [matTooltip]="config.tooltip"
      [ngClass]="config.class"
      (click)="focusInput(inputRef)"
    >
      @if (formLabel) {
        <mat-label>{{ formLabel }}</mat-label>
      }
      <input
        #inputRef
        matInput
        class="text-center"
        type="number"
        min="0"
        [disabled]="config.isReadOnly || config.isDisabled"
        [(ngModel)]="value"
        (keypress)="onlyNumberKey($event)"
        (keyup)="handleValueChanged()"
      />
    </mat-form-field>
  </div>
} @else if (config.type === 'icon') {
  <div
    [ngClass]="config.class"
    [class.cursor-not-allowed]="!config.shouldDetectClick || config.isDisabled"
    [matTooltip]="config.tooltip"
  >
    <button type="button" mat-icon-button [disabled]="!config.shouldDetectClick || config.isDisabled" (click)="handleIconClick()">
      @if (config.icon) {
        <mat-icon [class.text-black]="config.shouldDetectClick && !config.isDisabled">{{ config.icon }}</mat-icon>
      } @else if (config.svgIcon) {
        <mat-icon [class.text-black]="config.shouldDetectClick && !config.isDisabled" [svgIcon]="config.svgIcon" />
      } @else if (!config.icon && !config.svgIcon) {
        <mat-icon [class.text-black]="config.shouldDetectClick && !config.isDisabled">{{ value }}</mat-icon>
      }
    </button>
  </div>
} @else if (config.type === 'value-icon') {
  <div
    class="flex items-center justify-center"
    [ngClass]="config.class"
    [class.cursor-not-allowed]="!config.shouldDetectClick || config.isDisabled"
    [matTooltip]="config.tooltip"
  >
    @if (value === true) {
      <button type="button" mat-icon-button [disabled]="!config.shouldDetectClick || config.isDisabled">
        <mat-icon>{{ config.icon }}</mat-icon>
      </button>
    } @else if (value === false) {
      <mat-spinner [diameter]="30" />
    }
  </div>
} @else if (config.type === 'value-disabled-icon') {
  <div
    class="flex items-center justify-center"
    [ngClass]="config.class"
    [class.cursor-not-allowed]="!value"
    [matTooltip]="!value ? config.tooltip : ''"
  >
    <button type="button" mat-icon-button [disabled]="!value" (click)="handleIconClick()">
      @if (config.icon) {
        <mat-icon>{{ config.icon }}</mat-icon>
      } @else if (config.svgIcon) {
        <mat-icon [svgIcon]="config.svgIcon" />
      }
    </button>
  </div>
} @else if (config.type === 'image') {
  <div class="flex items-center justify-end">
    <button type="button" (click)="handleIconClick()">
      <img alt="" [ngSrc]="'assets/images/' + config.icon + '.png'" [height]="config.imageHeight" [width]="config.imageWidth" />
    </button>
  </div>
} @else if (config.type === 'status') {
  <div class="flex items-center justify-start" [ngClass]="config.class">
    {{ value | status }}
  </div>
} @else if (config.type === 'spinner') {
  <div class="flex items-center justify-center">
    <mat-spinner [diameter]="30" />
  </div>
} @else {
  <div class="text-center">&mdash;</div>
}
